
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { GebindeDto } from "../../dtos/gebindeDto";
import rules from "@/store/rules";

@Component({
	components: {},
})
export default class GebindeComponent extends Vue {
	@Prop()
	private gebinde!: GebindeDto;
	private validGebinde: boolean = true;
	private requiredRule = rules.requiredRule;

	private weightRule = [
		(value: number) => !!value || "Gewicht muss angegeben werden",
		(value: number) => !isNaN(value) || "Bitte Zahl (ohne Komma) eingeben",
		(value: string) => parseInt(value) === parseFloat(value) || "Muss eine ganze Zahl sein.",
		(value: number) =>
			(value >= 1.0 && value < 40000) || "Gewicht muss zwischen 1kg und 40 Tonnen liegen",
	];
	private distanceRule = [
		(value: number) => !!value || "Mass muss angegeben werden",
		(value: number) => !isNaN(value) || "Bitte Zahl (ohne Komma) eingeben",
		(value: string) => parseInt(value) === parseFloat(value) || "Muss eine ganze Zahl sein.",
		(value: number) =>
			(value >= 10 && value < 1000) || "Mass muss zwischen 10cm und 10m liegen",
	];
	private paletteRule = [
		(value: number) => !!value || "Anzahl muss angegeben werden",
		(value: number) => !isNaN(value) || "Bitte Zahl (ohne Komma) eingeben",
		(value: string) => parseInt(value) === parseFloat(value) || "Muss eine ganze Zahl sein.",
		(value: number) => value >= 0 || "Anzahl muss positiv sein",
	];

	private save() {
		this.$emit("gebindeChanged", this.gebinde);
	}
}
